import type { ApplicationStatusEntry } from '@/hooks/use-my-applications'
import { isActiveApplicationStatus } from '@/utils/application-status'

/**
 * Applied > Saved > none — one lifecycle state per card.
 * When active application exists, bookmark is hidden (not disabled).
 */
export function showsCandidateSavedBookmark(
  application: Pick<ApplicationStatusEntry, 'status'> | null | undefined,
): boolean {
  if (application != null && isActiveApplicationStatus(application.status)) {
    return false
  }
  return true
}
